/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    GetReleaseStatusResponse,
    GetReleaseStatusResponseFromJSON,
    GetReleaseStatusResponseToJSON,
} from '../models';

export interface GetReleaseSendStatusRequest {
    releaseId: number;
}

/**
 * 
 */
export class LegacyPressReleaseEditorApi extends runtime.BaseAPI {

    /**
     * プレスリリースの配信ステータス・配信時間を確認するAPI
     */
    async getReleaseSendStatusRaw(requestParameters: GetReleaseSendStatusRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetReleaseStatusResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling getReleaseSendStatus.');
        }

        const queryParameters: any = {};

        if (requestParameters.releaseId !== undefined) {
            queryParameters['release_id'] = requestParameters.releaseId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/t_release_send_status.php`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReleaseStatusResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースの配信ステータス・配信時間を確認するAPI
     */
    async getReleaseSendStatus(requestParameters: GetReleaseSendStatusRequest, initOverrides?: RequestInit): Promise<GetReleaseStatusResponse> {
        const response = await this.getReleaseSendStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
